import * as ActionCreators from './actionCreators';
import { appConstants } from '../constants/appConstants';
import { methodConstants } from '../constants/methodConstants';
import * as ErrorActions from './errorActions';
import * as Http from '../api/http';
import * as CommonActions from './commonActions';
import * as DefaultActions from './defaultActions';
import { initialManuallyEnteredValues } from '../initializeObjects/bankAccountFilters';

let bankAccFilterObj = {};
const initializePage = 1;

export const setSelectedDate = (date, property) => (dispatch, getState) => {
  bankAccFilterObj = getState().bankAccountFilters;
  bankAccFilterObj[property] = date;
  dispatch(ActionCreators.bankAccountFilters(bankAccFilterObj));
};
export const setFromDate = (date, isValidate) => (dispatch) => {
  if(isValidate)
    dispatch(validateManuallyEnteredDate(date, 'fromDate'));
  dispatch(setSelectedDate(date, 'fromDate'));
};
  
export const setToDate = (date, isValidate) => (dispatch) => {
  if(isValidate)
    dispatch(validateManuallyEnteredDate(date, 'toDate'));
  dispatch(setSelectedDate(date, 'toDate'));
};

export function isPointsBankCheck(banks, bankId){
  let val = false;
  if(banks.length > 0 ){
    banks.forEach(bank => {
      if(bank.id === bankId){
        if(bank.isPointsBank){
          val = true;
        }
      }
    });
  }
  return val;
}


export const setSortBy = (sort) => (dispatch, getState) => {
  const currentState = getState();
  const trans = currentState.translations;
  bankAccFilterObj = currentState.bankAccountFilters;
  const bankId = currentState.activeBankId;
  const bankPagination = currentState.pagination;
  if((bankAccFilterObj.fromDate === '' || bankAccFilterObj.toDate === '' )|| (CommonActions.isDefined(bankAccFilterObj.fromDate) && CommonActions.isDefined(bankAccFilterObj.toDate))){
    const errorMsg = CommonActions.validateDates(bankAccFilterObj.fromDate, bankAccFilterObj.toDate);
    if(errorMsg){
      const obj = {
        statusText: trans['error.start-end-msg']
      };
      dispatch(ErrorActions.displayError(obj));
    } else{
      bankAccFilterObj.sortBy = sort;
      dispatch(ActionCreators.bankAccountFilters(bankAccFilterObj));
      const isPointsBank = isPointsBankCheck(currentState.banks, bankId);
      dispatch(getBankDetails(bankId, bankPagination.pageSelected, isPointsBank, true));
    }
  }
  
};

export const applyBankAccountFilters = (translated) => (dispatch, getState) => {
  const currentState = getState();
  const trans = currentState.translations;
  const bankAccountFilters = currentState.bankAccountFilters;
  if(CommonActions.isDefined(bankAccountFilters.fromDate) && CommonActions.isDefined(bankAccountFilters.toDate)){
    const errorMsg = CommonActions.validateDates(bankAccountFilters.fromDate, bankAccountFilters.toDate);
    if(errorMsg){
      const obj = {
        statusText: trans['error.start-end-msg']
      };
      dispatch(ErrorActions.displayError(obj));
    } else{
      const bankId = currentState.activeBankId;
      const isPointsBank = isPointsBankCheck(currentState.banks, bankId);
      dispatch(getBankDetails(bankId, 1, isPointsBank));
    }
  }else if(CommonActions.checkDateFilter(bankAccountFilters) && translated !==  true){
    const obj = {
      statusText: trans['date-status-text']
    };
    dispatch(ErrorActions.displayError(obj));
  }else if(translated){
    const bankId = currentState.activeBankId;
    const bankPagination = currentState.pagination;
    if(bankId){
      const isPointsBank = isPointsBankCheck(currentState.banks, bankId);
      dispatch(getBankDetails(bankId, bankPagination.pageSelected, isPointsBank));
    }
    else{
      dispatch(DefaultActions.getBankDetails());
    }
  }
};

export const updatePagination = (summary, pageNumber) => (dispatch, getState) => {
  const customPagination = getState().pagination;
  const viewsPerPage = getState().viewsPerPage;
  CommonActions.preparePagination(customPagination,summary.total, viewsPerPage, pageNumber);
  dispatch(ActionCreators.pagination(customPagination));
  dispatch(ActionCreators.displayLoader(false));
};

export const bankAccountTransactions = (bankTransactions, pageNumber) => (dispatch) => {
  //const customerDateFormat = getState().customerDateFormat;
  const pointTrxs = bankTransactions.collection;
  // pointTrxs.forEach(function(transaction){
  //   //transaction.date = CommonActions.getDateGenericFormat(transaction.activityDate);
  //   transaction.date = CommonActions.getDateGenericFormatTimeZone(transaction.activityDate, customerDateFormat);
  // });
  dispatch(ActionCreators.isDisplayBankViewCatalog(bankTransactions.showCatalog));
  dispatch(ActionCreators.bankAccountTransactions(pointTrxs));
  if (pointTrxs.length !== 0) {
    dispatch(updatePagination(bankTransactions, pageNumber));
  }else{
    dispatch(ActionCreators.displayLoader(false));
  }
};

export const getBankDetails = (bankId, pageNumber, isPointsBank, isSort = false) => (dispatch, getState) => {
  const currentState = getState();
  const bankName = currentState.bankNameSelected;
  bankId = currentState.activeBankId;
  if(bankName === appConstants.POINTS || isPointsBank){
    dispatch(getBankAccountSummary(bankId, pageNumber, isSort));
    dispatch(ActionCreators.isDisplayBankDetailsLink(true));
  }else if (bankName !== ''){
    dispatch(getAccessCodeBankAccountSummary(bankId, pageNumber, isSort));
    dispatch(ActionCreators.isDisplayBankDetailsLink(false));
  }
};

export const getBankAccountSummary = (bankId, pageNumber, isSort) => (dispatch, getState) => {
  const currentState = getState();
  const bankAccountFilters = currentState.bankAccountFilters;
  dispatch(ActionCreators.displayLoader(true));
  let bankSummaryAPI = CommonActions.getFullApiUrl(methodConstants.GET_BANKACCOUNT_SUMMARY_POINTS, currentState);
  bankSummaryAPI = CommonActions.modifyString(bankSummaryAPI, '{:bankId}', bankId);
  if(CommonActions.checkDateFilter(bankAccountFilters)){
    bankAccountFilters.fromDate = '';
    bankAccountFilters.toDate = '';
  }
  const params = {
    'startDate': CommonActions.getDateInSpecificFormat(bankAccountFilters.fromDate),
    'endDate': CommonActions.getDateInSpecificFormat(bankAccountFilters.toDate),
    'page.start': pageNumber-1,
    'page.size': currentState.viewsPerPage
  };

  if(isSort){
    params['sort.column'] = 'activityDate';
    params['sort.order'] = bankAccountFilters.sortBy ? bankAccountFilters.sortBy : 'desc';
  }

  params['nocache'] = Date.now().toString();

  Http.get(bankSummaryAPI, currentState, params).then((res) => {
    dispatch(bankAccountTransactions(res, pageNumber));
    CommonActions.scrollToTop();
    CommonActions.setFocusTrap();
    const pathName = appConstants.ROUTE_BANK_ACCOUNT;
    const url = CommonActions.getFullApiUrl(pathName, currentState);
    dispatch(ActionCreators.displayLoader(false));
    dispatch(CommonActions.route(url));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const getAccessCodeBankAccountSummary = (bankId, pageNumber, isSort) => (dispatch, getState) => {
  const currentState = getState();
  const bankAccountFilters = currentState.bankAccountFilters;
  dispatch(ActionCreators.displayLoader(true));
  let bankSummaryAPI = CommonActions.getFullApiUrl(methodConstants.GET_BANKACCOUNT_SUMMARY_ACCESS, currentState);
  bankSummaryAPI = CommonActions.modifyString(bankSummaryAPI, '{:bankId}', bankId);
  if(CommonActions.checkDateFilter(bankAccountFilters)){
    bankAccountFilters.fromDate = '';
    bankAccountFilters.toDate = '';
  }
  const params = {
    'startDate': CommonActions.getDateInSpecificFormat(bankAccountFilters.fromDate),
    'endDate': CommonActions.getDateInSpecificFormat(bankAccountFilters.toDate),
    'page.start': pageNumber-1,
    'page.size': currentState.viewsPerPage
  };

  if(isSort){
    params['sort.column'] = 'activityDate';
    params['sort.order'] = bankAccountFilters.sortBy ? bankAccountFilters.sortBy : 'desc';
  }

  params['nocache'] = Date.now().toString();

  Http.get(bankSummaryAPI, currentState, params).then((res) => {
    CommonActions.scrollToTop();
    CommonActions.setFocusTrap();
    dispatch(bankAccountTransactions(res, pageNumber));
    dispatch(ActionCreators.displayLoader(false));
    const pathName = appConstants.ROUTE_BANK_ACCOUNT;
    const url = CommonActions.getFullApiUrl(pathName, currentState);
    dispatch(CommonActions.route(url));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const onPrintBankDetails = (bankId, pageNumber, type, link) => (dispatch, getState) => {
  let errorFlag = false;
  if(type !== undefined){
    type = type.toLowerCase();
  }
  const currentState = getState();
  const trans = currentState.translations;
  const bankAccountFilters = currentState.bankAccountFilters;
  dispatch(ActionCreators.displayLoader(true));
  let endPoint = '';
  const bankName = currentState.bankNameSelected;
  const isPointsBank = isPointsBankCheck(currentState.banks, bankId);
  if((bankName === appConstants.POINTS) || (bankName === appConstants.BANK) || isPointsBank){
    endPoint = methodConstants.GET_BANKACCOUNT_SUMMARY_POINTS;
  }else if (bankName !== ''){
    endPoint = methodConstants.GET_BANKACCOUNT_SUMMARY_ACCESS;
  }
  let bankSummaryAPI = CommonActions.getFullApiUrl(endPoint, currentState);
  bankSummaryAPI = CommonActions.modifyString(bankSummaryAPI, '{:bankId}', bankId);
  if(CommonActions.isDefined(bankAccountFilters.fromDate) && CommonActions.isDefined(bankAccountFilters.toDate)){
    const errorMsg = CommonActions.validateDates(bankAccountFilters.fromDate, bankAccountFilters.toDate);
    if(errorMsg){
      const obj = {
        statusText: trans['error.start-end-msg']
      };
      errorFlag = true;
      dispatch(ErrorActions.displayError(obj));
    }
  }
  if(CommonActions.checkDateFilter(bankAccountFilters)){
    bankAccountFilters.fromDate = '';
    bankAccountFilters.toDate = '';
    dispatch(ActionCreators.bankAccountFilters(bankAccountFilters));
    
  }
  if(!errorFlag){
    const params = {
      'startDate': CommonActions.getDateInSpecificFormat(bankAccountFilters.fromDate),
      'endDate': CommonActions.getDateInSpecificFormat(bankAccountFilters.toDate),
      'page.start': pageNumber-1,
      'page.size': currentState.viewsPerPage,
      'download': type,
      'nocache': Date.now().toString()
    };
    Http.get(bankSummaryAPI, currentState, params).then((res) => {
      if(link === appConstants.PRINT)
        CommonActions.getFileOpenFromByteArray(res, CommonActions.getExtension(type));
      else{
        const customerDateFormat = getState().customerDateFormat;
        const personalInfoValues = getState().personalInfoValues;
        const fileName = `${personalInfoValues ? personalInfoValues.fullName: 'BankReport'}_${CommonActions.getDateInSpecificFormat(new Date(), customerDateFormat ? customerDateFormat.toUpperCase(): 'DD-MM-YYYY')}`;
        CommonActions.downloadFileFromByteArray(res, fileName, CommonActions.getExtension(type));
      }
      dispatch(ActionCreators.displayLoader(false));
    })
      .catch((err) => {
        dispatch(ErrorActions.displayError(err));
      });
  }
};

export const onPagination = (page, pageAction) => (dispatch, getState) => {
  const currentState = getState();
  const bankPagination = currentState.pagination;
  const bankId = currentState.activeBankId;
  let specificPage = 0;
  let selectedPage = 1;
  if (pageAction) {
    if (typeof page === appConstants.TYPE_OF_OBJECT) {
      specificPage = page.item;
    } else if (typeof page === appConstants.TYPE_OF_STRING) {
      if (page === appConstants.PREVIOUS) {
        specificPage = bankPagination.pageSelected - 1;
      } else {
        specificPage = bankPagination.pageSelected + 1;
      }
    }
    if (specificPage !== bankPagination.pageSelected) {
      //dispatch(ActionCreators.displayLoader(true));
      selectedPage = specificPage;
      const isPointsBank = isPointsBankCheck(currentState.banks, bankId);
      dispatch(getBankDetails(bankId, selectedPage, isPointsBank));
      //dispatch(ActionCreators.displayLoader(false));
    }
  }
};

export const setViewsPerPage = (viewsPerPage) => (dispatch, getState) => {
  const currentState = getState();
  const bankId = currentState.activeBankId;
  if(currentState.viewsPerPage !== viewsPerPage)
    dispatch(ActionCreators.viewsPerPage(viewsPerPage));
  const isPointsBank = isPointsBankCheck(currentState.banks, bankId);
  dispatch(getBankDetails(bankId, initializePage, isPointsBank));
};

export const setActiveTab = (index, name, bankid, isClear) => (dispatch, getState) => {
  setDateCalendar('', false);
  const currentState = getState();
  const banks = currentState.banks;
  const trans = currentState.translations;
  let indexVal = -1;
  let isPointsBank = false;
  banks.forEach((bank, val) => {
    //let bankName = bank.name.split(' ');
    const bankName = bank.name;
    //bankName = bankName[0];
    if(bank.id.toString() === bankid.toString() && 
      (name === bankName || name.length === 0 || 
        name === appConstants.ACCESS_CODES || name === appConstants.POINTS ||
        name === appConstants.ACCESS_CODES_NAME ||
        name === trans['bank-account-access-code-tab-label'] || name === trans['bank-account-available-access-codes'] )){
      indexVal = val;
      if(bank.isPointsBank){
        isPointsBank = true;
        if (name.length === 0)
          name = appConstants.POINTS;
      }else if(bank.isAccessCodeBank && name.length === 0){
        name = appConstants.ACCESS_CODES;
      }
    }
  });
  if(index === -1){
    index = indexVal;
  }
  if(indexVal !== -1){
    //dispatch(ActionCreators.availableAccessCodeCount(banks[indexVal].points));
    dispatch(ActionCreators.tabSelected(index));
  }
  const bankAccountFilters = currentState.bankAccountFilters;
  bankAccountFilters.sortBy = '';
  if(!isClear){
    const viewsPerPage = 10;
    dispatch(ActionCreators.viewsPerPage(viewsPerPage));
  }
  dispatch(ActionCreators.bankAccountFilters(bankAccountFilters));
  if(name)
    dispatch(ActionCreators.bankNameSelected(name));
  if(bankid)
    dispatch(ActionCreators.activeBankId(bankid));
  const bankId = currentState.activeBankId;
  if(index !== -1){
    dispatch(getBankDetails(bankId, initializePage, isPointsBank));
    dispatch(ActionCreators.availableAccessCodeCount(banks[indexVal].points));
  }
};

export const openDownloadDropdown = (isOpen) => (dispatch) => {
  dispatch(ActionCreators.downloadDropdownOpen(!isOpen));
};


export const displayBankActions = (display) => (dispatch) => {
  dispatch(ActionCreators.isDisplayBankDialogActions(display));
  CommonActions.setBodyScroll(display);
  CommonActions.activateFocusTrapTwo(display);
};

export const displayProgramActions = (display) => (dispatch) => {
  dispatch(ActionCreators.isDisplayProgramDialogActions(display));
  CommonActions.setBodyScroll(display);
  CommonActions.activateFocusTrap(display);
};


export const getDetailsAlerts = (bankId, display, data) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let alertsAPI = CommonActions.getFullApiUrl(methodConstants.GET_ACCOUNT_DETAILS_ALERT_API, currentState);
  alertsAPI = CommonActions.modifyString(alertsAPI, '{:bankId}', bankId);
  const detailsAlertsRows = [];
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(alertsAPI, currentState, request).then((res) => {
    if(res && res.collection && res.collection.length > 0){
      res.collection.forEach ((item) => {
        const row = {};
        row.expirationText = item.text;
        row.expirationCount = item.count;
        detailsAlertsRows.push(row);
      });
      data.expiration = detailsAlertsRows;
      dispatch(ActionCreators.bankDetailValues(data));
      dispatch(displayBankActions(display));
      dispatch(ActionCreators.isDisplayDetailsAlerts(true));
    } else{
      dispatch(ActionCreators.isDisplayDetailsAlerts(false));
      dispatch(ActionCreators.bankDetailValues(data));
      dispatch(displayBankActions(display));
    }
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });

};

export const getBalanceDetails = (bankId, display) => (dispatch, getState) => {
  const data = {};
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  const banks = currentState.banks;
  banks.forEach((bank) => {
    if(bank.id.toString() === bankId.toString()){
      data.deposits = bank.pointsDeposited;
      data.withdrawals = bank.pointsWithdrawn;
      data.available= bank.pointsBalance;
      dispatch(getDetailsAlerts(bankId, display, data));
      dispatch(ActionCreators.displayLoader(false));
    }
  });
};

export const getActivePrograms = (bankId, display) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let bankProgramAPI = CommonActions.getFullApiUrl(methodConstants.GET_BANK_ACTIVE_PROGRAMS, currentState);
  bankProgramAPI = CommonActions.modifyString(bankProgramAPI, '{:bankId}', bankId);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(bankProgramAPI, currentState, request).then((res) => {
    dispatch(ActionCreators.programDetailValues(res));
    dispatch(displayProgramActions(display));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const clearFilters = () => (dispatch, getState) => {
  const currentState = getState();
  const bankFilters = currentState.bankAccountFilters;
  bankFilters.fromDate = '';
  bankFilters.toDate = '';
  if(document.getElementById('from-date') && document.getElementById('to-date')){
    document.getElementById('from-date').value = '';
    document.getElementById('to-date').value = '';
  }
  dispatch(ActionCreators.bankAccountFilters(bankFilters));
};

export const clearSearchResults = () => (dispatch, getState) => {
  const currentState = getState();
  dispatch(clearFilters());
  dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
  dispatch(setActiveTab(-1, currentState.bankNameSelected, currentState.activeBankId, true));
};

export const getCatalog = (accessId) => (dispatch, getState) => {
  const currentState = getState();
  let catalogAPI = CommonActions.getFullApiUrl(methodConstants.GET_CATALOG_API, currentState);
  catalogAPI = catalogAPI+'?accessCode='+accessId;
  window.open(catalogAPI);
};

export const setDateCalendar = (property, display) => (dispatch) => {
  const isDisplay = display ===  false ? false : true;
  if(property === 'from'){
    dispatch(ActionCreators.isDisplayFromDateCalendar(isDisplay));
  }else if(property === 'to'){
    dispatch(ActionCreators.isDisplayToDateCalendar(isDisplay));
  }else{
    dispatch(ActionCreators.isDisplayFromDateCalendar(isDisplay));
    dispatch(ActionCreators.isDisplayToDateCalendar(isDisplay));
  }
};

export const onDaySelected = (date, modifiers, charCode) => (dispatch) => {
  if (!modifiers.disabled) {
    dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
    dispatch(setFromDate(date));
    dispatch(setDateCalendar('from', false));
    if (charCode === appConstants.DAY_PICKER_ENTER_ACTION ) { // 0 for react day picker enter
      const ele = document.querySelector('.display-end-toggle .toggle-switch .react-switch-handle');
      if (ele) {
        ele.focus();
      }
    }
  }
  
};

export const onEndDaySelected = (date, modifiers, charCode) => (dispatch) => {
  if (!modifiers.disabled) {
    dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
    dispatch(setToDate(date));
    dispatch(setDateCalendar('to', false));
    if (charCode === appConstants.DAY_PICKER_ENTER_ACTION ) { // 0 for react day picker enter
      //const ele = document.querySelector('.display-end-toggle .toggle-switch .react-switch-handle');
      const ele = document.querySelector('.button');
      if (ele) {
        ele.focus();
      }
    }
  }
};

export const validateManuallyEnteredDate = (enteredDate, prop) => (dispatch, getState) => {
  const currentState = getState();
  const obj = currentState.manuallyEnteredDate;
  let isEnteredDatevalid = true;
  if(currentState.manuallyEnteredDate) {
    if(enteredDate) {
      if(enteredDate.length >= appConstants.MANUALLY_ENTERED_DATE.minDateLength) {
        let date = CommonActions.splitDate(enteredDate);
        if(date.length === 3) {
          if(date[2].length === appConstants.MANUALLY_ENTERED_DATE.minYearLength && date[0]!=='0' && date[0]!==''){
            date = CommonActions.formatManuallyEnteredDate(date);
            if(date.toString() !== appConstants.INVALID_DATE){
              enteredDate = CommonActions.checkDateFormat(date);
            }else{
              isEnteredDatevalid = false;
            }
          }else{
            isEnteredDatevalid = false;
          }
        }else{
          isEnteredDatevalid = false;
        }
      }
      if(!isEnteredDatevalid) {
        obj[prop] = '';
        dispatch(ActionCreators.manuallyEnteredDate(obj));
      }

    }
    obj[prop] = enteredDate;
    dispatch(ActionCreators.manuallyEnteredDate(obj));
  }
  
};
